import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IEmailTemplate } from "../interface/emails/IEmailTemplate";
import { generateQueryString } from "src/util/helper";

enum TemplateEmailEnum {
  getAllTemplatesEmail = "/get-all",
  getTemplateById = "/get-by-id",
  saveOrUpdateTemplateEmail = "/save-or-update"
}

export default class TemplateEmailService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/template-email");
  }

  public getAllTemplates = async (): Promise<IEmailTemplate[]> => await this.GET(TemplateEmailEnum.getAllTemplatesEmail);
  public getTemplateById = async (id: number): Promise<IEmailTemplate> => await this.GET(`${TemplateEmailEnum.getTemplateById}?${generateQueryString({ id })}`);
  public saveOrUpdateTemplateEmail = async (template: Omit<IEmailTemplate, "id">): Promise<void> => await this.POST(TemplateEmailEnum.saveOrUpdateTemplateEmail, template);
}
